import axios from "axios";
import { API_URL, MEDIA_API_URL } from "../../constants";

export const CreatePostApi = async (body,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    try {
        let res = await axios.post(MEDIA_API_URL + 'posts/create_post',body, {
            headers: {
                'Authorization': "Bearer " + token
            },
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}